import { render, staticRenderFns } from "./addDetailsNewContent.vue?vue&type=template&id=52f218c6&scoped=true&"
import script from "./addDetailsNewContent.vue?vue&type=script&lang=ts&"
export * from "./addDetailsNewContent.vue?vue&type=script&lang=ts&"
import style0 from "./addDetailsNewContent.vue?vue&type=style&index=0&id=52f218c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f218c6",
  null
  
)

export default component.exports